import React, { useMemo } from 'react'
import { numCol, strCol } from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import CommonScreen from '../admin/component/CommonScreen'
import { yesNoMap } from '../core/utils'
import * as api from '../api/pgads'

const title = 'Additional Event Tags'

const Card97ExtSpec = () => {
  const headerWithFormatter = useMemo(
    _ =>
      Card97ExtSpecHeaders.map(h =>
        h.ident.includes('readonly')
          ? {
              ...h,
              ...toSelectionColProps(yesNoMap),
            }
          : h
      ),
    []
  )

  return (
    <CommonScreen
      withUnitSelection={false}
      isAdminScreen
      title={title}
      header={headerWithFormatter}
      saveTask={api.saveCard97ExtensionSpec}
      retrieveTask={api.getCard97ExtensionSpec}
      autoRetrieve
      allowInsert={false}
      withDelete={false}
      sortOptions={Card97ExtSpecHeaders}
      widthOffset={100}
      heightOffset={270}
      autoFixColByKey={false}
      headerRowHeight={60}
    />
  )
}

export default Card97ExtSpec

export const Card97ExtSpecHeaders = [
  strCol({
    ident: 'header1',
    display: 'Header 1',
    alignment: 'left',
  }),
  strCol({
    ident: 'readonly1',
    display: 'ReadOnly 1',
  }),
  numCol({
    ident: 'minVal1',
    display: 'Min-Val 1',
    displayFormat: '0',
    alignment: 'right',
  }),
  numCol({
    ident: 'maxVal1',
    display: 'Max-Val 1',
    displayFormat: '0',
    alignment: 'right',
  }),
  strCol({
    ident: 'header2',
    display: 'Header 2',
    alignment: 'left',
  }),
  strCol({
    ident: 'readonly2',
    display: 'ReadOnly 2',
  }),
  numCol({
    ident: 'minVal2',
    display: 'Min-Val 2',
    displayFormat: '0',
    alignment: 'right',
  }),
  numCol({
    ident: 'maxVal2',
    display: 'Max-Val 2',
    displayFormat: '0',
    alignment: 'right',
  }),
  strCol({
    ident: 'header3',
    display: 'Header 3',
    alignment: 'left',
  }),
  strCol({
    ident: 'readonly3',
    display: 'ReadOnly 3',
  }),
  numCol({
    ident: 'minVal3',
    display: 'Min-Val 3',
    displayFormat: '0',
    alignment: 'right',
  }),
  numCol({
    ident: 'maxVal3',
    display: 'Max-Val 3',
    displayFormat: '0',
    alignment: 'right',
  }),
  strCol({
    ident: 'header4',
    display: 'Header 4',
    alignment: 'left',
  }),
  strCol({
    ident: 'readonly4',
    display: 'ReadOnly 4',
  }),
  numCol({
    ident: 'minVal4',
    display: 'Min-Val 4',
    displayFormat: '0',
    alignment: 'right',
  }),
  numCol({
    ident: 'maxVal4',
    display: 'Max-Val 4',
    displayFormat: '0',
    alignment: 'right',
  }),
  strCol({
    ident: 'header5',
    display: 'Header 5',
    alignment: 'left',
  }),
  strCol({
    ident: 'readonly5',
    display: 'ReadOnly 5',
  }),
  strCol({
    ident: 'header6',
    display: 'Header 6',
    alignment: 'left',
  }),
  strCol({
    ident: 'readonly6',
    display: 'ReadOnly 6',
  }),
  strCol({
    ident: 'header7',
    display: 'Header 7',
    alignment: 'left',
  }),
  strCol({
    ident: 'readonly7',
    display: 'ReadOnly 7',
  }),
  strCol({
    ident: 'header8',
    display: 'Header 8',
    alignment: 'left',
  }),
  strCol({
    ident: 'readonly8',
    display: 'ReadOnly 8',
  }),
]
